import { Check } from "lucide-react";
import { Reveal, Eyebrow } from "./motion";
import { PhotoFrame } from "./Placeholders";
import { Btn } from "./Buttons";
import { CONSULENZA, requestLink } from "../../data/site";

export const ConsulenzaTerzoSettore = () => (
  <section data-testid="consulenza-terzo-settore" className="bg-white py-20 md:py-28">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
      <Reveal>
        <PhotoFrame src="/media/terzo-settore.jpg" label="Consulenza per il Terzo Settore" className="aspect-[1200/630] rounded-[28px]" testId="consulenza-photo" />
      </Reveal>
      <div>
        <Reveal><Eyebrow>Consulenza</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 text-3xl font-semibold leading-tight text-navy md:text-[2.6rem]">Consulenza per il Terzo Settore.</h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base leading-relaxed text-slate2 md:text-lg">
            Accompagniamo associazioni, cooperative e organizzazioni sanitarie nel loro percorso di crescita, sviluppo e strutturazione.
          </p>
        </Reveal>
        <ul className="mt-8 space-y-4">
          {CONSULENZA.map((c, i) => (
            <Reveal as="li" key={c} delay={0.1 * i} y={12} className="flex items-start gap-3 text-base text-navy">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-gold/60"><Check className="h-3.5 w-3.5 text-gold-ink" /></span>
              {c}
            </Reveal>
          ))}
        </ul>
        <Reveal delay={0.2} className="mt-10">
          <Btn to={requestLink("altro")} testId="consulenza-cta-btn">Richiedi una consulenza</Btn>
        </Reveal>
      </div>
    </div>
  </section>
);
